import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';

import { media } from '../../styles/constants';

const BackgroundSvg = styled.svg`
  z-index: -1;
  position: absolute;
  top: 5rem;
  left: 50%;
  transform: translateX(-50%);

  @media (min-width: ${media.desktop}) {
    top: 0;
  }
`;

const BackgroundCircles = () => (
  <BackgroundSvg
    width="1131px"
    height="726px"
    viewBox="0 0 1131 726"
    version="1.1"
  >
    <g
      stroke="none"
      strokeWidth="1"
      fill="none"
      fillRule="evenodd"
      opacity="0.7"
    >
      <g transform="translate(-105.000000, -2016.000000)">
        <g transform="translate(105.000000, 2016.000000)">
          <circle fill="#FFA000" cx="346.5" cy="346.5" r="346.5" />
          <circle
            fill="#FB16BB"
            style={{ mixBlendMode: 'overlay' }}
            cx="829.5"
            cy="424.5"
            r="301.5"
          />
        </g>
      </g>
    </g>
  </BackgroundSvg>
);

const RelativeContainer = styled.div`
  position: relative;
`;

const ChildrenContainer = styled.div`
  display: flex;
  flex-wrap: wrap;
  margin-bottom: 10rem;

  @media (min-width: ${media.tabletLandscape}) {
    margin-right: -3rem;
  }

  /* [Style] Tweak here to change the layout of each observation */
  > a,
  > div {
    margin-bottom: 2rem;
    flex-grow: 1;
    flex-shrink: 0;
    flex-basis: 100%;

    @media (min-width: ${media.tabletPortrait}) {
      flex-grow: 0;
      flex-basis: calc(50% - 1rem);
      margin-right: 2rem;
      margin-bottom: 2rem;
      height: 18.5rem;

      &:nth-child(2n) {
        margin-right: 0;
      }
    }

    @media (min-width: ${media.tabletLandscape}) {
      flex-basis: calc(33% - 2rem);

      &:nth-child(2n) {
        margin-right: 2rem;
      }

      &:nth-child(3n) {
        margin-right: 0;
      }
    }

    @media (min-width: ${media.bigDesktop}) {
      margin-bottom: 5.5rem;
      max-height: 50rem;
    }
  }
`;

const ObservationsContainer = ({ children, hasBackground }) => (
  <RelativeContainer>
    {hasBackground && <BackgroundCircles />}
    <ChildrenContainer>{children}</ChildrenContainer>
  </RelativeContainer>
);

ObservationsContainer.propTypes = {
  hasBackground: PropTypes.bool,
  children: PropTypes.oneOfType([
    PropTypes.arrayOf(PropTypes.node),
    PropTypes.node
  ]).isRequired
};

ObservationsContainer.defaultProps = {
  hasBackground: false
};

export default ObservationsContainer;
